import { render, staticRenderFns } from "./pexCont.vue?vue&type=template&id=721d5818&scoped=true&"
import script from "./pexCont.vue?vue&type=script&lang=js&"
export * from "./pexCont.vue?vue&type=script&lang=js&"
import style0 from "./pexCont.vue?vue&type=style&index=0&id=721d5818&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721d5818",
  null
  
)

export default component.exports